import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from '../ContentLoader/ContentLoader';
import Grid from '../Grid/Grid';
import './FullPageLoader.scss';

const FullPageLoader = ({
  content,
}) => {
  const { config } = window;
  return (
    <div className="page-loader-container">
      <Grid>
        <div className="col-md-12 d-flex center-horizontally">
          <ContentLoader isLarge />
        </div>
        <div className="col-md-12 center-horizontally">
          <h2>
            {content || config.appName}
          </h2>
        </div>
      </Grid>
    </div>
  );
};

FullPageLoader.propTypes = {
  content: PropTypes.string,
};

FullPageLoader.defaultProps = {
  content: undefined,
};

export default FullPageLoader;
